export default __webpack_public_path__ + "static/media/arrow.fd5f10c8.svg";